<template lang="html">
<div class="gamelist-template">
  <table-data
    class="games"
    :items="games"
    @select="selectGame"
    @remove="removeGame"
  >
    <game-cell
      slot="item"
      slot-scope="props"
      :cell-data="props.itemdata"
      :cell-index="props.itemindex"
    />
  </table-data>
  <button
    class="button color-blue-500 start-button"
    @click="startGame()"
  >Nouvelle partie</button>
</div>
</template>

<script>
import gamesStore from './../store/GamesStore'
import TableData from '../view/table/TableData'
import GameCell from './GameCell'

export default {
  components: {
    TableData,
    GameCell,
  },
  data() {
    return {
      games: gamesStore.state.games
    }
  },
  methods: {
    startGame() {
      const twoDigits = x => x < 10 ? `0${x}` : `${x}`
      const today = new Date()
      const dd = twoDigits(today.getDate())
      const mm = twoDigits(today.getMonth())
      const yyyy = today.getFullYear()
      const h = twoDigits(today.getHours())
      const m = twoDigits(today.getMinutes())
      const name = `${dd}/${mm}/${yyyy} - ${h}:${m}`
      const gameID = gamesStore.addGame(name)
      gamesStore.setCurrentGame(gameID)
      this.$emit('onPushState', 'player-list', false)
    },
    selectGame(gameID) {
      gamesStore.setCurrentGame(gameID)
      if (gamesStore.state.currentGame.hasPlayers()) {
        this.$emit('onPushState', 'game')
      } else {
        this.$emit('onPushState', 'player-list', false)
      }
    },
    removeGame(gameID) {
      const response = confirm('Voulez vous vraiment supprimer cette partie ?')
      if (response) {
        setTimeout(() => gamesStore.removeGame(gameID), 500)
      }
    }
  },
}
</script>

<style lang="stylus">
@import '../styles/common'

.gamelist-template
  text-align center

  .games
    height calc(100% - 60px)

  .start-button
    font-size 1.4em
</style>



// WEBPACK FOOTER //
// GameList.vue?13f9e6c8